import { handleActions } from "redux-actions";

import * as types from "redux/actions/actionTypes";
import { orderFieldsByName } from "utilities/utils";

// Initial State
const initialState = {
  deployment: null,
};

// Reducer
const deployments = handleActions(
  {
    [types.DEPLOYMENT_ONE + types.SUCCESS_POSTFIX]: (state, action) => ({
      ...state,
      deployment: {
        ...action.data,
        input_fields: orderFieldsByName(action.data.input_fields),
        output_fields: orderFieldsByName(action.data.output_fields),
      },
    }),
    [types.DEPLOYMENT_ONE + types.RESET_POSTFIX]: (state, action) => ({
      ...state,
      deployment: null,
    }),
  },
  initialState
);

export default deployments;
